/** This file is auto generated by convertSvgToJsx.ts */

import React from 'react'
const information_circled = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 17 17"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.04 11.581h-.513c-.567 0-1.027-.46-1.027-1.027V7.986a.514.514 0 0 0-.514-.513h-.513m.674-2.487h.024M16.203 8.5a7.703 7.703 0 1 1-15.406 0 7.703 7.703 0 0 1 15.406 0Z"
    />
  </svg>
)
export default information_circled
